export default "__VITE_ASSET__RYLUehoO__"